angular.module('picmonicng').component('quizSidebar', {
  templateUrl: '/templates/app/components/quiz-sidebar/quiz-sidebar.html',
  bindings: {},
  controller: [
    '$scope',
    'QuizService',
    'LearnService',
    'UserService',
    'FactsResource',
    '$timeout',
    'XpService',
    'hotkeys',
    function ($scope, QuizService, LearnService, UserService, FactsResource, $timeout, XpService, hotkeys) {
      var ctrl = this;
      $scope.QuizService = QuizService;
      $scope.UserService = UserService;

      ctrl.$onDestroy = function () {
        if (QuizService.quizInProgress) {
          QuizService.endQuiz();
        }
      };

      var hotkey_bindings = hotkeys.bindTo($scope);
      QuizService.addHotKeys(hotkey_bindings);

      $scope.createDistractor = function (item) {
        $scope.distractorsLoading = true;
        if (item) {
          FactsResource.savev3(
            {
              fact_id: QuizService.currentQuestion.fact.fact_id,
              distractor_id: item.fact_id,
              resource: 'distractors',
            },
            function (data) {
              QuizService.currentQuestion.showDistractors.push(data);
              $scope.distractorsLoading = false;
            }
          );
        } else if (QuizService.newDistractor) {
          FactsResource.savev3(
            {
              fact_id: QuizService.currentQuestion.fact.fact_id,
              name: QuizService.newDistractor,
              resource: 'distractors',
            },
            function (data) {
              QuizService.currentQuestion.showDistractors.push(data);
              $scope.distractorsLoading = false;
            }
          );
        }
        QuizService.newDistractor = null;
      };

      $scope.downvoteDistractor = function (distractor, $event, source) {
        if (!source) {
          source = 'suggest_improvements';
        }
        $scope.distractorsLoading = true;

        var vote = -1;
        if (distractor.vote == -1) {
          vote = 0;
        }
        distractor.vote = vote;
        angular.forEach(QuizService.currentQuestion.answers, function (distractor) {
          distractor.showFeedback = false;
        });

        angular.forEach(QuizService.currentQuestion.userDistractors, function (distractor) {
          distractor.showFeedback = false;
        });

        angular.forEach(QuizService.currentQuestion.showDistractors, function (distractor) {
          distractor.showFeedback = false;
        });

        FactsResource.updatev3(
          {
            fact_id: QuizService.currentQuestion.fact.fact_id,
            question: QuizService.currentQuestion.question,
            distractor_id: distractor.fact_id,
            resource: 'distractors',
            vote: vote,
            source: source,
          },
          function (data) {
            distractor.vote = data.vote;
            $scope.distractorsLoading = false;

            XpService.grant('DistractorVote', data.user_fact_distractor_id, $event.currentTarget);
          }
        );

        if (
          vote == -1 &&
          QuizService.currentQuestion.picmonic.entity_type_id == 2 &&
          QuizService.currentQuestion.fact.entity_type_id == 2
        ) {
          distractor.showFeedback = true;
        }
      };

      $scope.upvoteDistractor = function (distractor, $event, source) {
        if (!source) {
          source = 'suggest_improvements';
        }
        $scope.distractorsLoading = true;
        var vote = 1;
        if (distractor.vote == 1) {
          vote = 0;
        }
        distractor.vote = vote;
        angular.forEach(QuizService.currentQuestion.answers, function (distractor) {
          distractor.showFeedback = false;
        });

        angular.forEach(QuizService.currentQuestion.userDistractors, function (distractor) {
          distractor.showFeedback = false;
        });

        angular.forEach(QuizService.currentQuestion.showDistractors, function (distractor) {
          distractor.showFeedback = false;
        });

        FactsResource.updatev3(
          {
            fact_id: QuizService.currentQuestion.fact.fact_id,
            question: QuizService.currentQuestion.question,
            distractor_id: distractor.fact_id,
            resource: 'distractors',
            vote: vote,
            source: source,
          },
          function (data) {
            distractor.vote = data.vote;
            $scope.distractorsLoading = false;

            XpService.grant('DistractorVote', data.user_fact_distractor_id, $event.currentTarget);
          }
        );
      };

      $scope.autoSuggestDropdown = function () {
        var autosuggest = angular.element('#distractor-autosuggest');
        $timeout(function () {
          var scroller = angular.element('.quiz-suggestion-container');
          var top = scroller.scrollTop() - scroller.offset().top + autosuggest.offset().top - 16;
          scroller.animate({ scrollTop: top }, 500);
        }, 0);
      };
    },
  ],
});
